// extracted by mini-css-extract-plugin
export default {"empty_state_document":"QMonthApproval_empty_state_document__P7ljf","empty_state_msg":"QMonthApproval_empty_state_msg__CXOPE"};